import _t from "../models/identifier.js";
import { getByteLength as er } from "../util/string-utils.js";
import oi from "../models/push-token.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
export default class bt {
  constructor(t, s) {
    (this.h = t), (this.B = s), (this.h = t), (this.B = s);
  }
  getUserId() {
    const t = this.B.$u(s.Ou.Cu);
    if (null == t) return null;
    let i = t.Tu,
      e = er(i);
    if (e > User.mr) {
      for (; e > User.mr; ) (i = i.slice(0, i.length - 1)), (e = er(i));
      (t.Tu = i), this.B.Iu(s.Ou.Cu, t);
    }
    return i;
  }
  Ju(t) {
    const i = null == this.getUserId();
    this.B.Iu(s.Ou.Cu, new _t(t)), i && this.B.Lu(t);
  }
  setCustomUserAttribute(t, s) {
    if (this.h.qu(t))
      return (
        E.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1
      );
    const i = {};
    return (i[t] = s), this.zu(User.Bu, i, !0);
  }
  zu(t, s, i = !1, e = !1) {
    const u = this.B.Eu(this.getUserId(), t, s);
    let o = "",
      r = t,
      h = s;
    return (
      i &&
        ((o = " custom"),
        "object" == typeof s &&
          ((r = Object.keys(s)[0]),
          (h = s[r]),
          "object" == typeof h && (h = JSON.stringify(h, null, 2)))),
      !e && u && E.info(`Logged${o} attribute ${r} with value ${h}`),
      u
    );
  }
  gu(t, i, e, u, o) {
    this.zu("push_token", t, !1, !0),
      this.zu("custom_push_public_key", e, !1, !0),
      this.zu("custom_push_user_auth", u, !1, !0),
      this.zu("custom_push_vapid_public_key", o, !1, !0);
    const r = et.Us.Rs,
      h = new et(r, E),
      n = new oi(t, i, e, u, o);
    this.B.bt(s.ft.Uu, n.gt()), h.setItem(r.Fs.Fu, r.fe, !0);
  }
  wu(t) {
    if (
      (this.zu("push_token", null, !1, !0),
      this.zu("custom_push_public_key", null, !1, !0),
      this.zu("custom_push_user_auth", null, !1, !0),
      this.zu("custom_push_vapid_public_key", null, !1, !0),
      t)
    ) {
      const t = et.Us.Rs,
        i = new et(t, E);
      this.B.bt(s.ft.Uu, !1), i.setItem(t.Fs.Fu, t.fe, !1);
    }
  }
}
